export const ADMIN_EDIT_USER = "ADMIN_EDIT_USER";
export const ADMIN_NEW_USER = "ADMIN_NEW_USER";
export const ADMIN_CONTENT = "ADMIN_CONTENT";
export const ADMIN_STATISTICS = "ADMIN_STATISTICS";
export const ADMIN_EDIT_USER_METADATA = "ADMIN_EDIT_USER_METADATA";
export const ADMIN_EDIT_ADDITIONAL_USER_METADATA = "ADMIN_EDIT_ADDITIONAL_USER_METADATA";

export const CLIPLIST_LIST_HEADER = "CLIPLIST_LIST_HEADER";
export const CLIPLIST_GRID = "CLIPLIST_GRID";
export const CLIPLIST_LIST = "CLIPLIST_LIST";
export const CLIPLIST_SIMPLE = "CLIPLIST_SIMPLE";
export const CLIPLIST_MINI = "CLIPLIST_MINI";
export const CLIPLIST_LIST_VIMEO = "CLIPLIST_LIST_VIMEO";
export const CLIPLIST_GRID_VIMEO = "CLIPLIST_GRID_VIMEO";
export const CLIPLIST_LIST_YOUTUBE = "CLIPLIST_LIST_YOUTUBE";
export const CLIPLIST_GRID_YOUTUBE = "CLIPLIST_GRID_YOUTUBE";

export const CLIPDETAILS = "CLIPDETAILS";
export const CLIPDETAIL_RELATED_HEADER = "CLIPDETAIL_RELATED_HEADER";
export const CLIPDETAIL_RELATED_DATA = "CLIPDETAIL_RELATED_DATA";
export const CLIPDETAIL_RELATED_ON_SORT = "CLIPDETAIL_RELATED_ON_SORT";
export const CLIPDETAIL_METADATA_DISTRIBUTION = "CLIPDETAIL_METADATA_DISTRIBUTION";

export const SIDEBAR_NEWSROOMTREE = "SIDEBAR_NEWSROOMTREE";
export const SIDEBAR_PANEL_WPS = "SIDEBAR_PANEL_WPS";
export const SIDEBAR_PMTREE = "SIDEBAR_PMTREE";
export const SIDEBAR_FILTER = "SIDEBAR_FILTER";

export const SIDEBAR_ADDITIONAL_PANELS = "SIDEBAR_ADDITIONAL_PANELS";

export const TOOLBAR_CONTROLS_LEFT = "TOOLBAR_CONTROLS_LEFT";
